// extracted by mini-css-extract-plugin
module.exports = {"button":"scroll-top-button_button__f8pFp","isVisible":"scroll-top-button_isVisible__LOEWd","icon":"scroll-top-button_icon__Hzis_"};